import { useTranslation } from 'react-i18next';

import { Pagination, Table } from '@treezor/design-system';

import { useLocation } from 'react-router';

import { EmptyState } from '@/ui-kit/templates/EmptyState/EmptyState';

import { useAllUsersTable } from '@/features/user/hooks/allUsers/useAllUsersTable';
import { AllUsersFilters } from '@/features/user/components/allUsers/AllUsersFilters';
import { ALL_USER__PER_PAGE } from '@/features/user/constants';

export function AllUsersTable() {
  const { t } = useTranslation();

  const state = useLocation().state || undefined;

  const { pagination, error, headers, rows, onPageChange, fields, hasFilters, onFilterChange, clearFilters } =
    useAllUsersTable(state);

  return (
    <div>
      <AllUsersFilters fields={fields} clearFunction={hasFilters ? () => onFilterChange(null) : undefined} />
      {error ? (
        <Table
          columns={headers}
          rows={[]}
          emptyComponent={
            <EmptyState
              title={t('components.molecules.table.noRecord')}
              icon="search_v1"
              size="m"
              className="p-6"
              action={t('components.molecules.table.tryClearFilters')}
              onClick={() => clearFilters()}
              buttonIcon={null}
            />
          }
        />
      ) : (
        <Table
          hasStickyHeader={true}
          columns={headers}
          rows={rows}
          emptyComponent={
            <EmptyState
              title={t('components.molecules.table.noRecord')}
              icon="search_v1"
              size="m"
              className="p-6"
              action={t('components.molecules.table.tryClearFilters')}
              onClick={() => clearFilters()}
              buttonIcon={null}
            />
          }
          className="bg-primary h-[calc(100vh-320px)] lightScrollBar"
        />
      )}
      <div className={'flex w-full justify-end'}>
        {pagination?.totalPages > 0 && !error && (
          <Pagination
            {...pagination}
            itemCount={pagination.totalPages * ALL_USER__PER_PAGE}
            itemPerPage={ALL_USER__PER_PAGE}
            onPageChange={(item: { selected: number }) => onPageChange(Number(item.selected) + 1)}
            isFirstButtonVisible
            isLastButtonVisible
            className="flex mt-4"
          />
        )}
      </div>
    </div>
  );
}
